import type { AnnouncementDoc, OrgBillingStatus } from "@a7y/types";

/**
 * A7Y-5621: the Weekly Bulletin's email is written held (`active: false`) and
 * sent only by a person pressing Broadcast; nothing else may send it.
 */
export function isWeeklyBulletin(announcement: AnnouncementDoc): boolean {
  return announcement.variant === "bulletin";
}

export function isHeldBulletin(announcement: AnnouncementDoc): boolean {
  return isWeeklyBulletin(announcement) && !announcement.active && !announcement.broadcastId;
}

export const BILLING_STATUS_OPTIONS: { value: OrgBillingStatus; label: string }[] = [
  { value: "trialing", label: "Trialing" },
  { value: "active", label: "Active" },
  { value: "canceled", label: "Canceled" },
  { value: "trial_expired", label: "Trial Expired" },
  { value: "sandbox", label: "Sandbox" },
];
